import { randomId } from "@/shared/utils/helpers.js";
import { copy } from "@/shared/utils/string";
import { ndasService } from "@/apps/legal/services/ndas.service";
import { legacyBannerService } from "@/shared/legacy/legacy-banner.service";
import { t } from "@/i18n";
import { parseHtml } from "@/shared/utils/string";

export default {
    namespaced: true,
    state: () => ({
        nda: {},
        ndas: [],
    }),
    actions: {
        async getNdas({ rootState, state }) {
            const footer = rootState.legal.footer;
            const ndas = await ndasService.getAllByFooterUuid(footer.uuid);
            state.ndas = ndas || [];
        },
        setCurrentNda({ state }, nda) {
            state.nda = nda;
        },
        addEmptyNda({ rootState, state }) {
            const nda = {
                id: randomId(),
                footerId: rootState.legal.footer.id,
            };
            state.ndas.push(nda);
            state.nda = nda;
        },
        async createNda({ dispatch }, nda) {
            const createdNda = await ndasService.createNda(nda);
            nda.id = createdNda.id;
            dispatch(
                "alert/showSuccessMessage",
                { title: t("legal.nda.nda_created") },
                { root: true }
            );
        },
        async updateNda({ dispatch }, nda) {
            await ndasService.updateNda(nda);
            dispatch(
                "alert/showSuccessMessage",
                { title: t("legal.nda.nda_changed") },
                { root: true }
            );
        },
        removeFromNdas({ state }, nda) {
            state.ndas = state.ndas.filter((n) => n.id !== nda.id);
        },
        replaceInNdas({ state }, nda) {
            const index = state.ndas.findIndex((n) => n.id === nda.id);
            state.ndas[index] = nda;
        },
        async deleteNda({ dispatch }, nda) {
            await ndasService.deleteNda(nda);
            dispatch("removeFromNdas", nda);
            dispatch(
                "alert/showSuccessMessage",
                { title: t("legal.nda.nda_deleted") },
                { root: true }
            );
        },
        async duplicateNda({ state, dispatch }, nda) {
            const duplicatedNda = await ndasService.createNda(nda);
            state.ndas.push(duplicatedNda);
            state.nda = duplicatedNda;
            dispatch(
                "alert/showSuccessMessage",
                { title: t("legal.nda.nda_cloned") },
                { root: true }
            );
        },
        async generatePdf({ rootState, dispatch }) {
            const link = document.createElement("link");
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("as", "style");
            link.setAttribute("href", "https://app.easy.tools/front/css/style.css");

            const contentDocument = rootState.legal.iframe.contentDocument;
            contentDocument.head.appendChild(link);

            const html = parseHtml(contentDocument.documentElement.outerHTML).replace(
                `<base href="/">`,
                `<base href="${location.origin}">`
            );

            const data = {
                html,
                styles: "button svg {display: none;} @page {size: A4; margin: 20mm; }",
                width: "800",
                height: "1140",
                buffer: false,
                fileType: "pdf",
                deviceScale: "1",
                orientation: "vertical",
            };

            try {
                const { url } = await legacyBannerService.makeCreation(data);

                dispatch("showDownloadImageModal", url);
            } finally {
                rootState.waiting = false;
                dispatch("setCurrentNda", {});
            }
        },
        showDownloadImageModal({ commit }, payload) {
            const modalData = {
                type: "code",
                title: t("legal.nda.document_ready"),
                desc: t("legal.nda.document_ready_desc"),
                code: payload,
                actionBtn: t("legal.nda.document_ready_cta"),
                cancelBtn: t("shared.cancel"),
                callback: () => {
                    copy(payload);
                    window.open(payload, "_blank");
                },
            };
            commit("showModal", modalData, { root: true });
        },
    },
};
